import { NativeInfoCmd, VJSBridge } from '@/libs/VJSBridge';
import { VJSBridgeFront } from '@/libs/VJSBridgeFront';
import { InitialGlobalData } from '@/types/global';
import { devAutoExecuteWrapper, timeoutPromiseWrapper } from '@/utils/request';

export const getInitialGlobalData = () => devAutoExecuteWrapper<InitialGlobalData>(
  NativeInfoCmd.GetInitialGlobalData,
  timeoutPromiseWrapper((res) => {
    VJSBridge.getVJSBridge().sendGetNativeInfoOperation(
      {
        cmd: NativeInfoCmd.GetInitialGlobalData,
      },
      (data: InitialGlobalData) => {
        res(data);
      },
    );
  }, {
    cmd: NativeInfoCmd.GetInitialGlobalData,
  }),
  {
    callbackId: VJSBridgeFront.getCallbackId() - 1,
  },
);

export const getNetworkType = () => devAutoExecuteWrapper<{ networkType: string }>(
  NativeInfoCmd.GetNetworkType,
  timeoutPromiseWrapper((res) => {
    VJSBridge.getVJSBridge().sendGetNativeInfoOperation(
      {
        cmd: NativeInfoCmd.GetInitialGlobalData,
      },
      (data: { networkType: string }) => {
        res(data);
      },
    );
  }, {
    cmd: NativeInfoCmd.GetInitialGlobalData,
  }),
  {
    callbackId: VJSBridgeFront.getCallbackId() - 1,
  },
);
